module.exports = __webpack_public_path__ + "static/img/pay2.5bdd2fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pay2.png
// module id = y827
// module chunks = 1